import * as React from 'react';
import { DocumentHead, PageTemplate } from 'lib/components';

import { Main } from './main';
import { useTranslation } from 'react-i18next';

export const IntegrationsPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <DocumentHead title={t('Integrations')} />
      <PageTemplate modal={[]} main={<Main />} />
    </>
  );
};
